export default {
  title: "Регистрация",
  toLoginMessage: "У меня уже есть профиль",
  subscribe: "Подписаться на уведомления Экспоцентра",
  consent1:
    "Настоящим я даю согласие на обработку моих персональных данных на указанных ниже",
  consent2: "условиях обработки персональных данных",
  submit: "Зарегистрироваться",
  successMessage:
    "Если аккаунт с указанным адресом существует и адрес электронной почты подтверждён, мы отправим ссылку для восстановления пароля.",

  error: {
    userExists: "Пользователь с таким e-mail уже существует.",
    validation: "Ошибка валидации.",
    userCreation: "Ошибка создания пользователя.",
    userElementCreation: "Ошибка создания элемента пользователя.",
    server: "Серверная ошибка"
  }
};
